import { ReactNode } from "react";
import clsx from "clsx";
import Button from "@/shared/ui/button/Button";
import Modal from "@/shared/ui/modal/Modal";

export type ConfirmProps = {
  children?: ReactNode;
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  pending?: boolean;
  confirmText?: string;
  cancelText?: string;
  title?: string;
  showCancel?: boolean;
  disableAnimation?: boolean;
  container?: string;
};

export default function Confirm({
  children,
  open,
  onConfirm,
  onCancel,
  pending,
  confirmText = "Да",
  cancelText = "Нет",
  title,
  showCancel = true,
  disableAnimation,
  container,
}: ConfirmProps) {
  return (
    <Modal
      open={open}
      onClose={onCancel}
      className="w-[18.125rem]"
      title={title}
      disableAnimation={disableAnimation}
      container={container}
    >
      <div className="flex flex-col gap-5 w-full">
        {children}
        <div className={clsx("grid gap-2", { "grid-cols-2": showCancel })}>
          <Button onClick={onConfirm} loading={pending} disabled={pending} className="h-[2.75rem]">
            {confirmText}
          </Button>
          {showCancel && (
            <Button
              variant="solid-surface-gradient"
              onClick={onCancel}
              disabled={pending}
              className="h-[2.75rem]"
            >
              {cancelText}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
}
